import { useEffect } from "react";
import { EventBus, Listener } from "../../lib";

export const useBusEvent = <Event>(
  eventBus: EventBus<Event>,
  listener: Listener<Event>
) => {
  useEffect(() => {
    const { unsubscribe } = eventBus.subscribe(listener);
    return () => unsubscribe();
  }, [listener]);
};
